var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"fill":_vm.iconColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }